import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, OnInit } from '@angular/core';
import { SentryService } from '@box-core/services';
import { Location, APIError } from '@box-types';
import { groupLocations } from '@box/utils';
import { finalize, map } from 'rxjs/operators';
import { LandingLocationsService } from './landing-locations.service';

@Component({
  selector: 'landing-locations',
  templateUrl: './landing-locations.component.html',
  styleUrls: ['./landing-locations.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [LandingLocationsService]
})
export class LandingLocationsComponent implements OnInit {
  public loading: boolean;
  public groupedLocations: { [key: string]: Location[] };

  constructor(
    private sentryService: SentryService,
    private changeDetectorRef: ChangeDetectorRef,
    private landingLocationsService: LandingLocationsService
  ) {}

  @HostBinding('class') public hostClass = 'landing-locations';

  ngOnInit(): void {
    this.initGroups();
  }

  private initGroups(): void {
    this.loading = true;
    this.landingLocationsService
      .fetchGroupedLocations()
      .pipe(
        map((locations) => groupLocations(locations)),
        finalize(() => {
          this.loading = false;
          this.changeDetectorRef.detectChanges();
        })
      )
      .subscribe({
        next: (groupedLocations) => (this.groupedLocations = groupedLocations),
        error: (error: APIError) =>
          this.sentryService.captureException(error, {
            domain: 'Landing',
            domainDetails: 'Landing Locations Component',
            severity: 'warning'
          })
      });
  }
}
